import React from 'react';
import TabBar from "../../components/TabBar";
import { SwitchInput } from "../../components/Form";
import { inject, observer } from "mobx-react/index";

@inject('ticketStore','workOrderStore')
@observer
class TripHome extends React.Component {

  onChangeSwitch = (key) => {
    const { ticketStore, workOrderStore } = this.props;
    workOrderStore.onChangeViewSwitch2(key)
    ticketStore.onChangeViewSwitch2(key);
    ticketStore.selectedMarker = null;
  };

  render() {
    const {  view_archived, assigned_to_all_trip } = this.props.ticketStore;

    return (
      <div>
        <div className='inline-grid space-between'>
          <TabBar
            items={[
              { to: '/monitoring/trip/tabular', label: 'Tabular' },
              { to: '/monitoring/trip/map', label: 'Map' },
              // { to: '/monitoring/ticket/archived', label: 'Archived' },
            ]}
          />
          <div className='inline-grid'>
            <SwitchInput label='Assigned to all' value={assigned_to_all_trip} onChange={() => this.onChangeSwitch('assigned_to_all_trip','trip')} />
            <SwitchInput label='View Archived' value={view_archived} onChange={() => this.onChangeSwitch('view_archived')} />
          </div>
        </div><br/>
        {this.props.children}
      </div>
    );
  }
}

export default TripHome;



// WEBPACK FOOTER //
// ./src/components/Trips/TripHome.js